import { type RefObject } from "react";

import { getStargateBaseUrl } from "@wac-web/libraries/bxp-web-stargate-client/src";
import { useLoggedInUser } from "@wac-web/utils/logged-in-user-provider";
import { useIntl } from "react-intl";

import AkFeedbackCollector, { FormFields } from "@atlaskit/feedback-collector";

import { messages } from "./messages";

const ENTRYPOINT_ID = "b06cac34-19fe-4a8a-bbf7-085cd5fd3d0c";

export const FeedbackCollectorModal = ({
    onClose,
    onSubmit,
    shouldReturnFocusRef
}: {
    onClose: () => void;
    onSubmit: (formFields: FormFields) => void;
    shouldReturnFocusRef: RefObject<HTMLElement>;
}) => {
    const { formatMessage } = useIntl();
    const userInfo = useLoggedInUser();
    const stargateBaseUrl = getStargateBaseUrl();

    return (
        <AkFeedbackCollector
            locale="en"
            customGatewayUrl={stargateBaseUrl}
            customFeedbackUrl={`${stargateBaseUrl}/feedback-collector-api`}
            atlassianAccountId={userInfo.accountId}
            email={userInfo.email}
            name={userInfo.name}
            shouldGetEntitlementDetails={false}
            entrypointId={ENTRYPOINT_ID}
            onClose={onClose}
            onSubmit={(formFields) => onSubmit(formFields)}
            shouldReturnFocusRef={shouldReturnFocusRef}
            feedbackTitle={formatMessage(messages.feedbackTitle)}
            feedbackTitleDetails={formatMessage(messages.feedbackTitleDetails)}
        />
    );
};
